import { render, staticRenderFns } from "./ai-hosting-setting.vue?vue&type=template&id=2c47407c&scoped=true&"
import script from "./ai-hosting-setting.vue?vue&type=script&lang=js&"
export * from "./ai-hosting-setting.vue?vue&type=script&lang=js&"
import style0 from "./ai-hosting-setting.vue?vue&type=style&index=0&id=2c47407c&lang=scss&scoped=true&"
import style1 from "./ai-hosting-setting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47407c",
  null
  
)

export default component.exports